<template>
    <div class="discrete-slider-many">
      <question class="mb-4" :text="$t(item.text)" />
      <b-row align-h="center">
        <b-col cols="12" sm="10" md="8">
        <div class="mt-3 mb-5 px-2 px-md-0" v-for="(option, i) in choices" :key="'slider-'+i">
          <slider
            :range="[item.scaleMin, item.scale]"
            :stepped="true"
            start="center"
            @change="handleSelect($event, option)"
            :labelMin="getLabel(option).min"
            :labelMax="getLabel(option).max"
            :show-range="false"
            :hide-step-labels="hideStepLabels"
          />
        </div>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import itemMixin from '@/components/mixins/itemMixin'
import question from '@/components/ui/question'
import slider from '@/components/inputs/slider'

export default {
  name: 'discreteSliderMany',
  mixins: [
    itemMixin
  ],
  components: {
    question,
    slider,
  },
  props: {
    item: {
      type: Object
    },
    itemProperties: {
      type: Object
    }
  },
  data() {
    return {
      results: []
    }
  },
  computed: {
    choices() {
        return this.item.choices.map(choice => {
            return {
                choice: choice.result
            }
        })
    },
    hideStepLabels() {
      return this.itemProperties.getProperty('hide_step_labels') === 'true'
    }
  },
  methods: {
    handleSelect(num, option) {
      if(this.results.find(resultItem => resultItem.choice === option.choice)) {
        const pos = this.results.findIndex(resultItem => resultItem.choice === option.choice)
        this.results[pos].result = num
      } else {
        option.result = num
        this.results.push(option)
      }

      if(this.results.length === this.choices.length) {
        this.$emit('answer', this.results)
      }
    },
    getLabel(option, i) {
      return {
        min: this.$t(`${this.item.text}_CHOICE_${option.choice}_MIN`),
        max: this.$t(`${this.item.text}_CHOICE_${option.choice}_MAX`)
      }
    },
  },
};
</script>
<style lang="scss">
  .simple-scale-item {
    height: 100%;
  }

  .discrete-slider-many {
    .vue-slider-mark {
      background: $main-font-grey--disabled;

      border-radius: 50%;
      height: 12px !important;
      width: 12px !important;
    }

    .vue-slider-mark-label {
      position: absolute;
      top: -45px !important;
      font-size: 0.75rem;


      @media screen and (max-width: 767px) {
        font-size: 0.625rem;
        top: -40px !important;
      }
    }
  }
</style>